export const IFRAME_CLICKED = 'IFRAME_CLICKED';
export const LAYOUT_RESIZED = 'LAYOUT_RESIZED';
export const LAYOUT_CHANGED = 'LAYOUT_CHANGED'; // e.g. size of elements changed => update position of absolute positioned tooltip
